module.exports = __webpack_public_path__ + "static/media/polonium_network_event_placeholder_3.e13401bb.png";